import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = auth
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("l30m_token");
    if (!t) { setUser(false); setChecking(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("l30m_token"); setUser(false); })
      .finally(() => setChecking(false));
  }, []);

  const loginAdmin = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("l30m_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginClient = async (code, email, password) => {
    const { data } = await api.post("/auth/client-login", { code, email, password });
    localStorage.setItem("l30m_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { localStorage.removeItem("l30m_token"); setUser(false); };

  return (
    <AuthContext.Provider value={{ user, checking, loginAdmin, loginClient, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
